import React from 'react';
import { Phone, CreditCard, Receipt, Heart, ArrowRight } from 'lucide-react';

interface DonationMessage {
  icon: React.ReactNode;
  text: string;
  highlight: string;
  action?: string;
  link?: string;
}

const DONATION_MESSAGES: DonationMessage[] = [
  {
    icon: <Phone className="w-5 h-5" />,
    text: "BLIK na telefon:",
    highlight: "664-821-160",
    action: "Wpłać teraz",
    link: "/wsparcie"
  },
  {
    icon: <Receipt className="w-5 h-5" />,
    text: "Przekaż 1.5% podatku - KRS:",
    highlight: "0000437387",
    action: "Dowiedz się więcej",
    link: "/przekaz-podatek"
  },
  {
    icon: <CreditCard className="w-5 h-5" />,
    text: "PayPal:",
    highlight: "przytulisko.jb@o2.pl",
    action: "Wpłać PayPal",
    link: "/wsparcie"
  },
  {
    icon: <Heart className="w-5 h-5" />,
    text: "Miesięczne koszty schroniska:",
    highlight: "22 000 zł",
    action: "Pomóż nam",
    link: "/wsparcie"
  }
];

interface DonationTopbarProps {
  isHome?: boolean;
  hideCostMessageOnHome?: boolean;
}

export function DonationTopbar({ isHome, hideCostMessageOnHome }: DonationTopbarProps) {
  const [currentMessage, setCurrentMessage] = React.useState(0);

  const messages = React.useMemo(() => {
    if (isHome && hideCostMessageOnHome) {
      return DONATION_MESSAGES.filter(m => m.text !== 'Miesięczne koszty schroniska:');
    }
    return DONATION_MESSAGES;
  }, [isHome, hideCostMessageOnHome]);

  React.useEffect(() => {
    if (messages.length === 0) return;
    const interval = setInterval(() => {
      setCurrentMessage((prev) => (prev + 1) % messages.length);
    }, 4000);

    return () => clearInterval(interval);
  }, [messages.length]);

  if (messages.length === 0) {
    return null;
  }

  const message = messages[currentMessage % messages.length];

  return (
    <div className="bg-accessible-red-600 text-white py-2 relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-accessible-red-700 via-accessible-red-600 to-accessible-red-700 animate-pulse"></div>
      <div className="relative max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-center gap-3 text-center">
          <div className="flex items-center gap-3">
            <div className="animate-bounce text-yellow-300">
              {message.icon}
            </div>
            <span className="text-sm font-medium text-white text-shadow-sm no-margin">
              {message.text}
            </span>
            <span className="font-bold text-base tracking-wide text-yellow-200 text-shadow-sm">
              {message.highlight}
            </span>
          </div>
          
          {message.action && (
            <div className="hidden sm:flex items-center gap-1">
              <span className="text-white/80">•</span>
              {message.link ? (
                <a 
                  href={message.link}
                  className="inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 px-2 py-1 rounded-full transition-colors text-xs font-bold text-white text-shadow-sm"
                >
                  <span>{message.action}</span>
                  <ArrowRight className="w-3 h-3" />
                </a>
              ) : (
                <button className="inline-flex items-center gap-1 bg-white/20 hover:bg-white/30 px-2 py-1 rounded-full transition-colors text-xs font-bold text-white text-shadow-sm">
                  <span>{message.action}</span>
                  <ArrowRight className="w-3 h-3" />
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}